const $ = require("jquery");

/**
 * @param revealDiv {HTMLDivElement}
 * @return {void}
 */
module.exports = function openFoundationModal(revealDiv) {
    if (window.Foundation && window.Foundation.Reveal) {
        const $revealDiv = $(revealDiv);
        const modal = new window.Foundation.Reveal($revealDiv);
        modal.open();
    }
}